module.exports = __webpack_public_path__ + "img/page3.fc5e37df.jpg";